import React, { useMemo } from 'react';
import c from 'classnames';
import { useCurrentRefinements } from 'react-instantsearch';

import type { SearchTopicalContentType } from '../types';

interface ChildProps {
  contentType: SearchTopicalContentType | undefined;
}

export interface SearchTopicalResultsProps {
  className?: string;
  children: (childProps: ChildProps) => React.ReactNode;
}

const SearchTopicalResults: React.FC<SearchTopicalResultsProps> = (props) => {
  const {
    className,
    children,
  } = props;

  const classNames = c('SearchTopical__Results', className);

  const { items } = useCurrentRefinements();

  const contentType = useMemo(() => (
    items.find((item) => item.attribute === 'type')?.refinements[0]?.value
  ), [items]) as SearchTopicalContentType | undefined;

  return (
    <div className={classNames}>
      {children({ contentType })}
    </div>
  );
};

export default SearchTopicalResults;
